import { LoadingScreen } from "../loading-screen/LoadingScreen";
import { useRequireAuth } from "@/hooks";

interface ProtectedPageProps {
  children: React.ReactNode;
  redirectTo?: string;
  requiredRoles?: string[];
  loadingComponent?: React.ReactNode;
}

export const ProtectedPage = ({
  children,
  redirectTo = "/login",
  requiredRoles = ["super_admin", "admin"],
  loadingComponent = <LoadingScreen />,
}: ProtectedPageProps) => {
  const { isLoading, isAuthenticated } = useRequireAuth({
    redirectTo,
    requiredRoles,
  });

  if (isLoading) return <>{loadingComponent}</>;
  if (!isAuthenticated) return null;

  return <>{children}</>;
};
